import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectTextToImages, selectTextToImagesLoading } from '../vb/reducer'
import useLightModePreference from '../util/useLightModePreference'
import * as CONSTANTS from './constants'
import { selectArtisticStyle } from './reducer'
import { setTextToImageError } from '../vb/actions'
import LoadingImage from './LoadingImage'
import GeneratedImage from './GeneratedImage'
import aiGrayLightModeIcon from './assets/ai-gray-icon.png'
import aiGrayDarkModeIcon from './assets/ai-gray-dark-mode-icon.png'
import { SHOWING_RESULTS } from './translation/resources'
import 'rc-dropdown/assets/index.css'
import './GeneratedImages.css'

const totalImages = 2

const GeneratedImages = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isTextToImagesLoading = useSelector(selectTextToImagesLoading)
  const textToImages = useSelector(selectTextToImages)
  const selectedArtisticStyle = useSelector(selectArtisticStyle)
  const isLightMode = useLightModePreference()
  const aiGrayIcon = isLightMode ? aiGrayLightModeIcon : aiGrayDarkModeIcon
  const [seconds, setSeconds] = useState(0)
  const loadingTimeOutInSeconds = 60

  useEffect(() => {
    let intervalId

    if (textToImages.length > 0 || seconds >= loadingTimeOutInSeconds) {
      clearInterval(intervalId)

      // Dispatch the error message when the timeout is exceeded
      if (seconds >= loadingTimeOutInSeconds) {
        dispatch(
          setTextToImageError(CONSTANTS.ERROR_MESSAGE_FAILED_TO_GENERATE)
        )
      }
    } else {
      intervalId = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 1)
      }, 1000)
    }

    return () => clearInterval(intervalId)
  }, [dispatch, textToImages, seconds])

  return (
    <div className="GeneratedImages">
      <div className="GeneratedImages__title-container">
        <img src={aiGrayIcon} alt="aiGrayIcon" />
        <p className="GeneratedImages__title">
          {t(SHOWING_RESULTS)}
          {selectedArtisticStyle && ` in ${t(selectedArtisticStyle)} style`}
        </p>
      </div>

      <div className="GeneratedImages__images">
        {isTextToImagesLoading
          ? Array.from({ length: totalImages }).map((_, index) => (
              <LoadingImage key={index} index={index} total={totalImages} />
            ))
          : textToImages.map((image, index) => (
              <GeneratedImage
                key={image.id}
                image={image}
                index={index}
                total={totalImages}
              />
            ))}
      </div>
    </div>
  )
}

export default GeneratedImages
